import {
  AlertTriangle, Ban, BookOpen, Briefcase, Camera, Clapperboard, Crosshair, DoorClosed, Eye, EyeOff, FileText, FileUser, Film,
  Fingerprint, Gavel, Gift, Hand, Handshake, Images, MessageCircle, Mic, Mountain, Newspaper, Package, PenLine, Pizza, Quote, Scale,
  Search, Shield, Siren, Sparkles, Spline, Stamp, Star, Store, Target, Theater, Timer, Trophy, Users, VenetianMask, Video, Vote,
  Zap, Type, Smartphone, ShieldCheck, Footprints, Crown, EarOff, Flag, type LucideIcon,
} from 'lucide-react';

/** Lucide icons referenced by name from game instruction steps. Unknown names fall back to Sparkles. */
const ICONS: Record<string, LucideIcon> = {
  AlertTriangle, Ban, BookOpen, Briefcase, Camera, Clapperboard, Crosshair, DoorClosed, Eye, EyeOff, FileText, FileUser, Film,
  Fingerprint, Gavel, Gift, Hand, Handshake, Images, MessageCircle, Mic, Mountain, Newspaper, Package, PenLine, Pizza, Quote, Scale,
  Search, Shield, Siren, Sparkles, Spline, Stamp, Star, Store, Target, Theater, Timer, Trophy, Users, VenetianMask, Video, Vote,
  Zap, Type, Smartphone, ShieldCheck, Footprints, Crown, EarOff, Flag,
};

export function NamedIcon({ name, size = 24, className }: { name: string; size?: number; className?: string }) {
  const I = ICONS[name] ?? Sparkles;
  return <I size={size} className={className} aria-hidden />;
}
